var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_460_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 0H1.74994C0.784973 0 0 0.784973 0 1.74994V6.24994C0 7.21509 0.784973 8.00006 1.74994 8.00006H9.24994C10.2151 8.00006 11.0001 7.21509 11.0001 6.24994V1.74994C11.0001 0.784973 10.2151 0 9.24994 0Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 9.99994H1.74994C0.784973 9.99994 0 10.7849 0 11.7501V22.2501C0 23.215 0.784973 24 1.74994 24H9.24994C10.2151 24 11.0001 23.215 11.0001 22.2501V11.7501C11.0001 10.7849 10.2151 9.99994 9.24994 9.99994Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 15.9999H14.75C13.7849 15.9999 12.9999 16.7849 12.9999 17.7501V22.2501C12.9999 23.215 13.7849 24 14.75 24H22.25C23.215 24 23.9999 23.215 23.9999 22.2501V17.7501C23.9999 16.7849 23.215 15.9999 22.25 15.9999Z",
    fill: "#C32A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 -7.62939e-06H14.75C13.7849 -7.62939e-06 12.9999 0.784966 12.9999 1.74993V12.2499C12.9999 13.2151 13.7849 14.0001 14.75 14.0001H22.25C23.215 14.0001 23.9999 13.2151 23.9999 12.2499V1.74993C23.9999 0.784966 23.215 -7.62939e-06 22.25 -7.62939e-06Z",
    fill: "#C32A7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_460_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.38455dfd4239c6ea68057cc2f4652e57.svg";
export { ForwardRef as ReactComponent };